<template>
  <div class="content-container">
    <!--头部文字-->
    <div class="list-title">
      <el-page-header style="font-size: 14px;" @back="$router.back()" content="ModBus数据采集配置"></el-page-header>
    </div>
    <!--项目编辑内容-->
    <div class="content-box">    
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="180px">
        <el-form-item label="服务类型">
          <span style="font-weight: bold;padding: 0 10px;">{{ ruleForm.type }}</span>
        </el-form-item>
        <el-form-item label="业务模板">
          <span style="font-weight: bold;padding: 0 10px;">ModBus数据采集</span>
        </el-form-item>
        <el-form-item label="服务名称" prop="name">
          <el-input v-model="ruleForm.name" style="width: 33%;min-width:350px;"></el-input>
        </el-form-item>

        <div class="form-link"></div>

        <el-form-item label="轮询周期(秒)" prop="pollingInterval">
          <el-input v-model.number="ruleForm.pollingInterval" style="width: 33%;min-width:350px;"></el-input>
        </el-form-item>
        
        <el-form-item label="设备配置" >
          <el-tabs v-model="activeName" type="border-card" @tab-click="tabClick" style="margin-right: 10px;">
            <el-tab-pane label="设备分类管理" name="deviceType">
              <el-button @click="editDeviceType()" style="margin-bottom: 10px;" icon="el-icon-plus" type="success">添加设备分类</el-button>
              <el-table :data="deviceTypeDatas" border style="min-width: 600px; max-width:1000px;">
                <el-table-column prop="name" label="分类名称"></el-table-column>
                <el-table-column prop="rmk" label="备注"></el-table-column>
                <el-table-column fixed="right" label="操作" width="200">
                  <template slot-scope="scope">
                    <el-link @click="editDeviceType(scope.row)" type="primary" :underline="false">编辑</el-link> &nbsp;&nbsp;
                    <el-link @click="locatorManager(scope.row)" type="primary" :underline="false">寄存器管理</el-link> &nbsp;&nbsp;
                    <el-link @click="delDeviceType(scope.row)" type="danger" :underline="false">删除</el-link>
                  </template>
                </el-table-column>
              </el-table>   
              <el-pagination style="margin-top: 20px;"
                @size-change="dtSizeChange"
                @current-change="dtCurrentChange"
                :current-page.sync="dtCurPage"
                :page-sizes="[10, 20, 30]"
                :page-size="dtCurSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="dtTotalCount">
              </el-pagination>
            </el-tab-pane>
            <el-tab-pane label="设备管理" name="device">
              <div class="list-control-panel" style="max-width:1000px;">
                <el-button @click="editDevice()" icon="el-icon-plus" type="success">添加设备</el-button>
                <div class="search-box">
                  <span class="search-box-label">设备分类: </span> 
                  <el-select v-model="devSearchValue" @change="devSearch" filterable clearable placeholder="请选择">
                    <el-option
                      v-for="item in deviceTypeSelect"
                      :key="item.number"
                      :label="item.name"
                      :value="item.number">
                    </el-option>
                  </el-select>
                </div>
              </div>              
              <el-table :data="deviceDatas" border style="min-width: 600px; max-width:1000px;">
                <el-table-column prop="deviceType.name" label="所属分类"></el-table-column>
                <el-table-column prop="ip" label="IP地址"></el-table-column>
                <el-table-column prop="port" label="端口"></el-table-column>
                <el-table-column prop="deviceId" label="设备自定义ID"></el-table-column>
                <el-table-column fixed="right" label="操作" width="100">
                  <template slot-scope="scope">
                    <el-link @click="editDevice(scope.row)" type="primary" :underline="false">编辑</el-link> &nbsp;&nbsp;
                    <el-link @click="delDevice(scope.row)" type="danger" :underline="false" >删除</el-link>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination style="margin-top: 20px;"
                @size-change="devSizeChange"
                @current-change="devCurrentChange"
                :current-page.sync="devCurPage"
                :page-sizes="[10, 20, 30]"
                :page-size="devCurSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="devTotalCount">
              </el-pagination>
            </el-tab-pane>
          </el-tabs>         
        </el-form-item>

        <el-form-item>
          <el-button @click="$router.back()">取消</el-button>
          <el-button type="primary" @click="onSubmit('ruleForm')">保存</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!--寄存器管理列表-->
    <el-dialog title="寄存器管理列表" :close-on-click-modal="false" :visible.sync="locatorManagerVisible" width="90%">
      <el-button @click="editLocator()" style="margin-bottom: 10px;" icon="el-icon-plus" type="success">添加寄存器</el-button>
      <el-table :data="locatorDatas" border height="50vh">
        <el-table-column prop="deviceType.name" label="所属分类"></el-table-column>
        <el-table-column prop="slaveId" label="slaveId"></el-table-column>
        <el-table-column prop="funCode" label="功能码" :formatter="formatFunCode"></el-table-column>
        <el-table-column prop="offset" label="寄存器起始地址"></el-table-column>
        <el-table-column prop="dataType" label="数据类型" :formatter="formatDataType"></el-table-column>
        <el-table-column prop="name" label="属性名称"></el-table-column>
        <el-table-column prop="labal" label="属性说明"></el-table-column>
        <el-table-column prop="component" label="设备部件"></el-table-column>
        <el-table-column prop="unit" label="单位"></el-table-column>
        <el-table-column fixed="right" label="操作" width="150">
          <template slot-scope="scope">
            <el-link @click="editLocator(scope.row)" type="primary" :underline="false">编辑</el-link> &nbsp;&nbsp;
            <el-link @click="delLocator(scope.row)" type="danger" :underline="false" >删除</el-link>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>


    <!--设备分类信息编辑-->
    <el-dialog title="设备分类编辑" :visible.sync="deviceTypeVisible" width="500px">
      <el-form label-position="right" label-width="100px" :rules="deviceTypeRules" ref="deviceTypeForm" :model="deviceTypeForm">
        <el-form-item label="分类名称" prop="name">
          <el-input v-model="deviceTypeForm.name"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="rmk">
          <el-input v-model="deviceTypeForm.rmk"></el-input>
        </el-form-item>        
        <el-form-item v-show="deviceTypeForm.number==null || typeof deviceTypeForm.number === 'undefined'" label="">
          <el-checkbox v-model="modelCheck" border>添加寄存器模板</el-checkbox>
        </el-form-item>     
      </el-form>
      
      <span slot="footer" class="dialog-footer">
        <el-button @click="deviceTypeVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitDeviceType('deviceTypeForm')">确 定</el-button>
      </span>
    </el-dialog>

    <!--设备信息编辑-->
    <el-dialog title="设备编辑" :visible.sync="deviceVisible" width="500px">
      <el-form label-position="right" label-width="120px" :rules="deviceRules" ref="deviceForm" :model="deviceForm">
        <el-form-item label="分类" prop="dtNumber">
          <el-select v-model="deviceForm.dtNumber" filterable clearable placeholder="请选择">
            <el-option
              v-for="item in deviceTypeSelect"
              :key="item.number"
              :label="item.name"
              :value="item.number">
            </el-option>
          </el-select>
        </el-form-item>       
        <el-form-item label="IP地址" prop="ip">
          <el-input v-model="deviceForm.ip"></el-input>
        </el-form-item>
        <el-form-item label="端 口" prop="port">
          <el-input v-model.number="deviceForm.port"></el-input>
        </el-form-item>
        <el-form-item label="设备自定义ID" prop="deviceId">
          <el-input v-model="deviceForm.deviceId"></el-input>
        </el-form-item>
      </el-form>
      
      <span slot="footer" class="dialog-footer">
        <el-button @click="deviceVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitDevice('deviceForm')">确 定</el-button>
      </span>
    </el-dialog>

    <!--设备寄存器信息编辑-->
    <el-dialog title="寄存器编辑" :visible.sync="locatorVisible" width="600px">
      <el-form label-position="right" label-width="150px" :rules="locatorRules" ref="locatorForm" :model="locatorForm">
        <el-form-item label="slaveId" prop="slaveId">
          <el-input v-model="locatorForm.slaveId" placeholder="Modbus从机地址(SlaveID)"></el-input>
        </el-form-item>
        <el-form-item label="功 能 码" prop="funCode">
          <el-select v-model="locatorForm.funCode" placeholder="请选择">
            <el-option
              v-for="item in funCodes"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="寄存器起始地址" prop="offset">
          <el-input v-model.number="locatorForm.offset" placeholder="寄存器起始地址(0 ~ n)"></el-input>
        </el-form-item>
        <el-form-item label="数据类型" prop="dataType">
          <el-select v-model="locatorForm.dataType" placeholder="请选择">
            <el-option
              v-for="item in dataTypes"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="属性名称" prop="name">
          <el-input v-model="locatorForm.name" placeholder="属性名称"></el-input>
        </el-form-item>
        <el-form-item label="属性说明">
          <el-input v-model="locatorForm.labal" placeholder="属性说明"></el-input>
        </el-form-item>        
        <el-form-item label="设备部件">
          <el-input v-model="locatorForm.component"></el-input>
        </el-form-item>
        <el-form-item label="单位">
          <el-input v-model="locatorForm.unit"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="locatorVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitLocator('locatorForm')">确 定</el-button>
      </span>
    </el-dialog>
  </div>    
</template>
<script>
export default {
  data() {
    return {
      activeName: 'deviceType',
      //设备分类 
      dtCurPage: 1,
      dtCurSize: 10,
      dtTotalCount: 0,
      deviceTypes:[], 
      deviceTypeDatas: [], //设备类型分页数据
      deviceTypeSelect:[], //下拉框数据
      //寄存器
      locCurPage: 1,
      locCurSize: 10,
      locTotalCount: 0,
      locSearchValue: "",
      locators:[],
      locatorDatas:[], //寄存器分页数据
      //设备
      devCurPage: 1,
      devCurSize: 10,
      devTotalCount: 0,
      devSearchValue: "",
      devices:[], //全局设备集合
      deviceDatas:[], //设备分页数据      
      dataTypes: this.$store.state.modbusDataTypes,
      funCodes: this.$store.state.modbusFunCodes,
      globalDeviceType: {},
      locatorManagerVisible: false,
      deviceVisible: false,
      deviceTypeVisible: false,
      deviceTypeForm:{},
      deviceForm:{},
      modelCheck: false,
      deviceTypeRules:{
        name:[
          {required: true, message: '请输入设备分类', trigger: 'blur'}
        ]
      },    
      deviceRules:{
        dtNumber: [
          {required: true, message: '请选择分类', trigger: 'blur'}
        ],
        ip:[
          {required: true, message: '请输入通讯地址', trigger: 'blur'}
        ],
        port:[
          {required: true, message: '请输入通讯端口', trigger: 'blur'},
          { type: 'number', message: '通讯端口必须为数字值', trigger: 'blur'}
        ],
        deviceId:[
          {required: true, message: '请输入设备自定义ID', trigger: 'blur'}
        ]        
      },      
      locatorVisible: false,
      locatorForm:{},
      locatorRules:{
        deviceType: [
          {required: true, message: '请选择分类', trigger: 'blur'}
        ],
        slaveId:[
          {required: true, message: '请输入通讯地址', trigger: 'blur'}
        ],
        funCode:[
          {required: true, message: '请选择功能码', trigger: 'blur'}
        ],
        offset:[
          {required: true, message: '请输入寄存器起始地址', trigger: 'blur'},
          { type: 'number', message: '寄存器起始地址必须为数字值', trigger: 'blur'}
        ],
        name:[
          {required: true, message: '请输入属性名称', trigger: 'blur'}
        ],
        dataType:[
          {required: true, message: '请选择数据类型', trigger: 'blur'}
        ]
      },
      ruleForm: {
        id: "",
        proType: "",
        type:"",
        name:"ModBus数据采集",
        business:"",
        businessName: "",
        pollingInterval: 30,
        reporType: "http",
      },
      rules:{
        name: [
          { required: true, message: '请输入服务名称', trigger: 'blur' }
        ],
        pollingInterval:[
          { required: true, message: '请输入轮询间隔', trigger: 'blur' },
          { type: 'number', message: '轮询间隔必须为数字值'}
        ],
        reporType: [
          { required: true, message: '请选择上报方式', trigger: 'blur' }
        ]
      },
    };
  },
  methods: {
    // 设备分类
    dtSizeChange(val) {
      this.dtCurSize = val;
      this.dtCurPage = 1;
      this.dtList();
    },
    dtCurrentChange(val) {
      this.dtList();
    },
    dtList(){
      let page = pageUtil(this.deviceTypes, this.dtCurPage, this.dtCurSize);
      this.dtTotalCount = page.totalCount;
      this.deviceTypeDatas = page.rows;
    },    
    // 寄存器
    locSizeChange(val) {
      this.locCurSize = val;
      this.locCurPage = 1;
      this.locList();
    },
    locCurrentChange(val) {      
      this.locList();
    },    
    locSearch(val){
      this.locCurPage = 1;
      this.locList();
    },
    locList(){
      let page = pageUtil(this.locators, this.locCurPage, this.locCurSize, "dtNumber", this.locSearchValue);
      this.locTotalCount = page.totalCount;
      this.locatorDatas = page.rows;
    },
    // 设备
    devSizeChange(val) {
      this.devCurSize = val;
      this.devCurPage = 1;
      this.devList();
    },
    devCurrentChange(val) {
      this.devList();
    },
    devSearch(val){
      this.devCurPage = 1;
      this.devList();
    },
    devList(){
      let page = pageUtil(this.devices, this.devCurPage, this.devCurSize, "dtNumber", this.devSearchValue);
      this.devTotalCount = page.totalCount;
      this.deviceDatas = page.rows;
    },
    tabClick(val){
      // if(val.name == "deviceType"){
      //   this.dtList();
      // }else if(val.name == "device"){
      //   this.devList();
      // }
    },
    addFormwork(){
      //检测 设备是否已存在
      for(let d of this.deviceDatas){
        if(d.ip == "127.0.0.1" && d.port == 502){
          this.$message({
            message: "127.0.0.1:502 设备信息已存在,请先删除该设备信息!",
            type: 'warning'
          });
          return false;
        }
      }

      let lcs = this.getModelLocator();
      this.deviceDatas.push({
        ip: '127.0.0.1',
        port: 502,
        deviceId: '1001',
        locators: lcs,
      });
    },
    getModelLocator(){
      let lcs = [];
      lcs.push({        
        slaveId: 1,
        funCode: "01",
        offset: 0,
        dataType: "0",
        name: "status1",
        bdelete: "0"
      });
      lcs.push({        
        slaveId: 1,
        funCode: "02",
        offset: 2,
        dataType: "0",
        name: "status2",
        bdelete: "0"
      });
      lcs.push({        
        slaveId: 1,
        funCode: "03",
        offset: 1,
        dataType: "1",
        name: "number1",
        bdelete: "0"
      });
      lcs.push({        
        slaveId: 1,
        funCode: "03",
        offset: 4,
        dataType: "2",
        name: "number2",
        bdelete: "0"
      });
      lcs.push({        
        slaveId: 1,
        funCode: "04",
        offset: 2,
        dataType: "5",
        name: "floatValue",
        bdelete: "0"
      });
      return lcs;
    },    
    editDeviceType(devType){//编辑设备信息
      if(devType){
        // this.deviceForm = Object.assign({}, dev);
        this.deviceTypeForm = devType;
      }else{
        this.deviceTypeForm = {
          name: "",
          rmk: "",
          bdelete: "0"
        };
      }
      this.modelCheck = false;
      this.deviceTypeVisible = true;
    },
    delDeviceType(devType){//删除设备信息
      let _this = this;
      this.$confirm('此操作将删除该分类相关的寄存器与设备数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if(devType.id){
          devType.bdelete = "1";
        }else{
          let index = _this.deviceTypes.indexOf(devType);
          _this.deviceTypes.splice(index, 1);
        }
        // 删除该分类相关的寄存器与设备数据
        for(let i = 0; i < _this.locators.length; i++){
          let loc = _this.locators[i];
          if(loc.dtNumber == devType.number){
            if(loc.id){
              loc.bdelete = "1";
            }else{
              this.locators.splice(i, 1);
              i--;
            }
          }          
        }
        for(let i = 0; i < _this.devices.length; i++){
          let dev = _this.devices[i];
          if(dev.dtNumber == devType.number){
            if(dev.id){
              dev.bdelete = "1";
            }else{
              this.devices.splice(i, 1);
              i--;
            }
          }          
        }
        _this.dtList();
        _this.devList();//更新设备列表，因为设备列表在切换tab时不会更新数据列表
        _this.deviceTypeSelect = searche(_this.deviceTypes); //更新下拉列表
      }).catch(() => {});      
    },
    submitDeviceType(formName){
      let _this = this;
      // 检测设备信息是否重复
      let dck = false;
      for(let d of _this.deviceTypeDatas){
        if(d.bdelete != 0){
          continue;
        }
        if(d != _this.deviceTypeForm && d.name == _this.deviceTypeForm.name){
          dck = true;
          break;
        }
      }
      if(dck){
        _this.$message({
          message: _this.deviceTypeForm.name + '设备分类已存在!',
          type: 'warning'
        });
        return false;
      }
      _this.$refs[formName].validate((valid) => {
        if (valid) {
          //添加设备类型列表
          if(!_this.deviceTypeForm.number){
            _this.deviceTypeForm.number = uuid(); //为新增设备分类添加ID
            _this.deviceTypes.push(_this.deviceTypeForm);
            _this.deviceTypeSelect = searche(_this.deviceTypes); //更新下拉列表
          }
          if(_this.modelCheck){
            let mlArr = _this.getModelLocator();
            for(let ml of mlArr){
              ml.ms = "1";
              ml.deviceType = _this.deviceTypeForm;
              ml.dtNumber = _this.deviceTypeForm.number;
              _this.locators.push(ml);
            }
          }

          //执行分页数据显示变更
          _this.dtList(); //当前列表
          
          _this.deviceTypeForm = {}
          _this.deviceTypeVisible = false;
        } else {
          return false;
        }
      });
    },
    editDevice(dev){//编辑设备信息
      if(dev){
        this.deviceForm = dev;
      }else{
        this.deviceForm = {
          ip: '127.0.0.1',
          port: 502,
          deviceId: '1001',
          bdelete: "0"
        };
      }
      this.deviceVisible = true;
    },
    delDevice(dev){//删除设备信息 
      let _this = this;
      _this.$confirm('是否删除该设备信息?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if(dev.id){
          dev.bdelete = "1";
        }else{
          let i = _this.devices.indexOf(dev);
          _this.devices.splice(i, 1);
        }
        _this.devList();
      }).catch(() => {});
    },
    submitDevice(formName){
      let _this = this;
      // 检测设备信息是否重复
      let dck = 0;
      for(let d of _this.devices){
        if(d.bdelete != 0){
          continue;
        }
        if(d != _this.deviceForm){
          if(d.ip == _this.deviceForm.ip && d.port == _this.deviceForm.port){
            dck = 1;
            break;
          }
          if(d.deviceId == _this.deviceForm.deviceId){
            dck = 2;
            break;
          }
        }        
      }
      if(dck == 1){
        _this.$message({
          message: _this.deviceForm.ip + ":" + _this.deviceForm.port +'设备信息已存在!',
          type: 'warning'
        });
        return false;
      } else if(dck == 2){
        _this.$message({
          message: _this.deviceForm.deviceId + '设备ID已存在!',
          type: 'warning'
        });
        return false;
      }
      _this.$refs[formName].validate((valid) => {
        if (valid) {
          //添加设备列表
          if(!_this.deviceForm.id && !_this.deviceForm.ms){            
            _this.deviceForm.ms = "1"; //临时标记属性 用于判断是否为新增数据
            _this.deviceForm.deviceType = searcheOne(_this.deviceTypes, "number", _this.deviceForm.dtNumber);
            _this.devices.push(_this.deviceForm);
          }
          this.devList();
          _this.deviceForm = {}
          _this.deviceVisible = false;
        } else {
          return false;
        }
      });
    },
    formatFunCode(row, column, cellValue, index){
      for(let fc of this.funCodes){
        if(row.funCode == fc.value){
          return fc.label;
        }
      }
      return "";
    },    
    formatDataType(row, column, cellValue, index){
      for(let fc of this.dataTypes){
        if(row.dataType == fc.value){
          return fc.label;
        }
      }
      return "";
    },
    locatorManager(val){
      this.globalDeviceType = val;
      this.locatorManagerVisible = true;
      //显示当前类型所属寄存器列表
      this.locatorDatas = searche(this.locators, "dtNumber", val.number);
    },
    editLocator(loc){//编辑寄存器信息
      if(loc){
        this.locatorForm = loc;
      }else{
        this.locatorForm = {
          funCode: "03",
          bdelete: "0"
        }
      }
      this.locatorVisible = true;
    },
    delLocator(loc){//删除寄存器信息
      let _this = this;
      _this.$confirm('是否确认删除寄存器信息?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if(loc.id){
          loc.bdelete = "1";
        }else{
          let i = _this.locators.indexOf(loc);
          _this.locators.splice(i, 1);
        }
        //显示当前类型所属寄存器列表
        _this.locatorDatas = searche(_this.locators, "dtNumber", _this.globalDeviceType.number);
      }).catch(() => {});
    },
    submitLocator(formName){
      let _this = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if(!_this.locatorForm.id && !_this.locatorForm.ms){            
            _this.locatorForm.ms = "1"; //临时标记属性 用于判断是否为新增数据
            _this.locatorForm.deviceType = _this.globalDeviceType;
            _this.locatorForm.dtNumber = _this.globalDeviceType.number;
            _this.locators.push(_this.locatorForm);
            _this.locatorDatas.push(_this.locatorForm);//更新列表数据
          }          
          _this.locatorForm = {};
          _this.locatorVisible = false;
        } else {
          return false;
        }
      });
    },
    onSubmit(formName){
      let _this = this;
      _this.$refs[formName].validate((valid) => {
        if (valid) {
          submit();
        } else {
          return false;
        }
      });
      function submit(){
        //检测是否添加设备信息
        if(_this.deviceTypes.length == 0){
          _this.$message({
              message: '请添加设备分类信息!',
              type: 'warning'
            });
            return false;
        }
        if(_this.locators.length == 0){
          _this.$message({
            message: '请添加寄存器信息!',
            type: 'warning'
          });
          return false;
        }
        if(_this.devices.length == 0){
          _this.$message({
            message: '请添加设备信息!',
            type: 'warning'
          });
          return false;
        }

        let formData = new FormData();
        formData.append("id", _this.ruleForm.id);
        formData.append("proType", _this.ruleForm.proType);
        formData.append("type", _this.ruleForm.type);
        formData.append("name", _this.ruleForm.name);
        formData.append("business", _this.ruleForm.business);
        let dataMap = {
          config: {
            pollingInterval: _this.ruleForm.pollingInterval,
            reporType: _this.ruleForm.reporType
          },
        }
        formData.append("configText", JSON.stringify(dataMap));

        formData.append("deviceTypes", JSON.stringify(_this.deviceTypes));//分类列表
        // 移除属性对象中的分类对象
        for(let loc of _this.locators){
          delete loc.deviceType;
          loc.config = {
            slaveId: loc.slaveId,
            funCode: loc.funCode,
            offset: loc.offset,
            dataType: loc.dataType,
            component: loc.component
          }
        }
        formData.append("attributes", JSON.stringify(_this.locators)); //属性列表
        // 移除设备对象中的分类对象
        for(let dev of _this.devices){
          delete dev.deviceType;          
        }
        formData.append("devices", JSON.stringify(_this.devices));//设备列表

        var uid = getCookieV('userid1');
        var token = getCookieV('token1');
        _this.axios({
          method: 'post',
          url: _this.api.saveServerProject,
          data: formData,
          params: {
            uid: uid,
            tk: token,
          },
        }).then(function(res){
          console.log(res);
          let data=res.data;
          if(data.code==-1){
              window.location.href=_this.api.loginHtmlUrl;
          }else if(data.code==200){
            _this.$message({
              message: '保存成功!',
              type: 'success'
            });
            _this.$router.push({name: 'list'});
          }else{
            _this.$message.error(data.msg);
          }
        }).catch(function(){
            commonErrorTip(_this);
        })
      }
    }
  },
  created() {
    // let _this = this;
    console.log("created");
  },
  mounted() {
    console.log("mounted");
    let _this = this;
    _this.$store.state.mainLeftMenu=1;
    var query = _this.$route.query;
    if(query.id != null && !(query.id === undefined) && !(query.id === "")){
      var uid = getCookieV('userid1');
      var token = getCookieV('token1');
      _this.axios({
        method: 'get',
        url: _this.api.queryByIdServerProject+"/"+query.id,
        params: {
          uid: uid,
          tk: token,
        },
      }).then(res=>{
        let data = res.data;
        if(data.code==200){
          let pro = data.data;
          let dm = JSON.parse(pro.configText);          
          pro.pollingInterval = dm.config.pollingInterval;
          pro.reporType = dm.config.reporType;
          _this.ruleForm = pro;

          //将分类、属性、设备信息还原出来
          _this.deviceTypes =JSON.parse(pro.deviceTypes);
          _this.dtList();//显示分类列表
          _this.deviceTypeSelect = searche(_this.deviceTypes); //更新下拉列表
          let locators = JSON.parse(pro.attributes);
          let devices = JSON.parse(pro.devices);

          // 根据dtNumber绑定分类对象
          let dts = {};
          for(let dt of _this.deviceTypes){
            dts[dt.number] = dt;
          }
          for(let dev of devices){
            let dt = dts[dev.dtNumber];
            if(dt){
              dev.deviceType = dt;
            }
          } 
          _this.devices = devices;
          _this.devList();//显示设备列表
          
          for(let loc of locators){
            //将config中的属性还原出来            
            if(loc.config){
              let cnf = JSON.parse(loc.config);
              Object.assign(loc, cnf);
            }            
            let dt = dts[loc.dtNumber];
            if(dt){       
              loc.deviceType = dt;
            }
          }
          _this.locators = locators;             
        }else if(data.code==-1){
            window.location.href=_this.api.loginHtmlUrl;
        }else{
          _this.$message.error(data.msg);
        }
      }).catch(function(){
          commonErrorTip(_this);
      })
    }else{
      _this.ruleForm.proType = query.proType;
      _this.ruleForm.type = query.type;
      _this.ruleForm.business = query.business;
    }
  },
};
</script>
<style lang="scss" scoped>
.list-div {
  position: relative;
  padding: 0 0 0 30px;
  height: 850px;
  width: 90%;
  left: 80px;
}
.list-title {
  position: relative;
  // left: 15px;
  font-size: 20px;
  color: #333;
  padding: 10px;
  border-bottom: 1px solid #dadada;
}
.steps-div{
  height: 300px;
  width: 200px;
  // background-color: #ffffff;
}
.edit-div{
  height: 100%;
}

.form-link{
  width: 100%;
  border-bottom: 1px solid #dadada;
  margin-bottom: 22px;
  box-shadow: 0 0 2px 2px #efefef;
}

.locator-div{
  position: relative;
  display: flex;
  width: 100%;
  flex-wrap: wrap;
}
.data-div{
  padding: 10px;
  width: 1000px;
  height: 400px;
  background: #fff;
  margin: 10px;
}

</style>